import React from 'react';
import SelectOption from '../../../infrastructure/types/SelectOption';
import './styles.scss';
import { generateKey } from '../../../infrastructure/helpers/react/commonHelper';

interface Props {
    left: string,
    top: string,
    options: SelectOption[],
    onOptionSelected: (selectedOption: SelectOption) => void;
}

class ContextMenu extends React.Component<Props> {

    render(): JSX.Element {
        return (
            <div id='contextMenu' className='bg-main-blue-color' style={{ display: 'block', position: 'fixed', left: this.props.left, top: this.props.top }}>
                {this.props.options.map((option) => {
                    return <span key={generateKey()} className='color-white' onClick={() => this.props.onOptionSelected(option)}>{option.value}</span>
                })
                }
            </div>
        )
    }
}

export default ContextMenu;